import React, { useState, useEffect, useContext, useCallback } from "react";
import Request from "common/Request";
import Result from "./Result";
import { parseSystemCPUUsage } from "./api.js";
import ActionsContext from "common/ActionsContext";
import { useBqnId } from "common/BqnContext";
import View from "common/View";
import useDebouncer from "common/hooks/debouncer";

const LOAD_INTERVAL = 3000;

const Report = () => {
  const actions = useContext(ActionsContext);
  const [request, setRequest] = useState(null);
  const [liveData, setLiveData] = useState(null);
  const bqnId = useBqnId();

  const debounce = useDebouncer(500 /*ms*/);

  useEffect(() => {
    let active = true;

    const cpuUsageRetrieval = () => {
      return ifCl
        .run("show system cpu")
        .then((input) => ({ cpus: parseSystemCPUUsage(input, bqnId) }));
    };

    const doLoad = () => {
      const req = cpuUsageRetrieval().then((data) => {
        if (active) setLiveData(data);
        return data;
      });
      setRequest(req);
    };

    const doBackgroundLoad = () => {
      cpuUsageRetrieval()
        .then((data) => {
          if (active) setLiveData(data);
        })
        .catch((err) => console.error("CPU background fetch failed:", err));
    };

    doLoad();
    const intervalId = setInterval(doBackgroundLoad, LOAD_INTERVAL);
    const unsubscribe = actions.recv("do-load", () => debounce(doLoad));

    return () => {
      active = false;
      clearInterval(intervalId);
      unsubscribe();
      debounce.stop();
    };
  }, [bqnId, debounce]);

  return (
    <Request during={request}>
      {() => (liveData ? <Result {...liveData} /> : null)}
    </Request>
  );
};

const CPUStatus = () => (
  <View title="CPU Usage">
    <Report />
  </View>
);

export default CPUStatus;
